import React from 'react'
import Banks from '../components/home/Banks'
import Hero from '../components/home/Hero'
import Keys from '../components/home/Keys'
import PreFooter from '../components/PreFooter'

function Home() {
  return (
    <>
      <Hero />
      <Keys />
      <Banks />
      <PreFooter />
    </>
  )
}

export default Home